import React from "react";
import {
    Bar,
    BarChart,

    Legend, ReferenceLine, Tooltip,


    XAxis, YAxis,

} from "recharts";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";




const AlarmesBarChart = (props) => {

    const  data  = props.data? props.data : [];

    const width = props.width? props.width : 300;
    const height = props.height? props.height : 300;
    const titulo = props.titulo? props.titulo : 'PARAMETROS DE CORRECAO';
    const maxBarSize = props.maxBarSize? { maxBarSize: props.maxBarSize} : {}

    const calcCorrecao = data => {
        return (data.qtde<0)? data.qtde * -1 : data.qtde ;
    }


    return(
        <Grid container item style={{backgroundColor: "white", width: width, height: height }}>

            <Grid item style={ {width: "100%", height: "100%", padding: 10}}>
                <BarChart
                    width={width}
                    height={height }
                    data={data}
                    layout={"vertical"}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >

                    <XAxis type="number" hide />
                    <YAxis type="category" minTickGap={1} tickCount={1} width={300} padding={{ left: 0 }} dataKey="mensagem"/>
                    <Bar dataKey={"qtde"} isAnimationActive={false} layout={"vertical"}   fill="#a8adb3" {...maxBarSize}  label={{ position: 'botton', fill:'black' }}   />


                </BarChart>


            </Grid>
        </Grid>
    );

}

export default AlarmesBarChart;